
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3.99999L10 0.535889H14L16 3.99999L14 7.46409L10 7.46409L8 3.99999ZM15 7.99999L17 4.53589L21 4.53589L23 7.99999L21 11.4641H19.9167C19.1696 11.1647 18.354 11 17.5 11C17.2485 11 17.0004 11.0143 16.7563 11.0421L15 7.99999ZM15.5877 11.2859L14 8.53589H10L8 12L10 15.4641H11.3252C11.982 13.4708 13.5771 11.9039 15.5877 11.2859ZM11.071 16.5359H10L8 20L10 23.4641H14L14.2071 23.1054C12.2879 21.9755 11 19.8882 11 17.5C11 17.1724 11.0242 16.8505 11.071 16.5359ZM1 16L3 12.5359H7L9 16L7 19.4641H3L1 16ZM3 4.53589L1 7.99999L3 11.4641H7L9 7.99999L7 4.53589L3 4.53589Z"></path><path d="M15 17L18 14L21 17H15Z"></path><path d="M15 19L18 22L21 19H15Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowAggregatesortFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
